var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faq-item"},[_c('h2',[_vm._v(_vm._s(_vm.question))]),_c('p',[_vm._v(_vm._s(_vm.answer))])])}
var staticRenderFns = []

export { render, staticRenderFns }